import script from "./PMPStep1Registro.vue?vue&type=script&setup=true&lang=js"
export * from "./PMPStep1Registro.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__